import { getRequestData } from 'api/api';
import { ROLE_TYPES } from 'api/constants';
import { endpoints } from 'api/endpoints';
import { useAuth } from 'context/authContext';
import React, { createContext, useEffect, useState, useContext, useCallback } from 'react';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const { partnerId, role, auth } = useAuth();
  const [userDetails, setUserDetails] = useState();

  useEffect(() => {
    const handler = () => {
      setUserDetails(null);
    };

    if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
      window.addEventListener('pf25:clearUserDetails', handler);
    }

    return () => {
      if (typeof window !== 'undefined' && typeof window.removeEventListener === 'function') {
        window.removeEventListener('pf25:clearUserDetails', handler);
      }
    };
  }, []);

  const storeUserDetails = (userData) => {
    setUserDetails(userData);
  };

  const updateUserDetails = useCallback(async () => {
    if (!auth) return;

    let { data } = await getRequestData(
      role === ROLE_TYPES.client ? endpoints.clientProfile : endpoints.getUserProfile,
      ROLE_TYPES[role],
    );

    if (partnerId) {
      const { data: partnerDetails } = await getRequestData(
        endpoints.getPartner(partnerId),
        ROLE_TYPES.slh_manager,
      );

      data = {
        ...data,
        partner_details: partnerDetails,
        partner_id: partnerId,
        partner_name: partnerDetails?.name,
        partner_address: partnerDetails?.address,
      };
    }

    setUserDetails(data);
  }, [partnerId, role, auth]);

  useEffect(() => {
    updateUserDetails();
  }, [updateUserDetails]);

  return (
    <UserContext.Provider value={{ userDetails, storeUserDetails, updateUserDetails }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  return useContext(UserContext);
};
